import React, { useEffect, useState } from "react";
import { Divider, Grid, Switch, useTheme } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import { InsertGorouhMoshtariData } from "Stores/actions";
import { read } from "Helpers/LocalStorage";
import Input from "Components/Input/Input";
import Translator from "Languages/Utility/Translator";
import MuiButton from "Components/MuiButton/MuiButton";
import * as R from "ramda";
import { useTranslation } from "react-i18next";
import { convertToEnglishNumber } from "Helpers/convertToEnglishNumber";

export default function NewCustomerGroup() {
  const { t } = useTranslation();
  const { direction } = useTheme();
  const dispatch = useDispatch();
  const [checkValid, setCheckValid] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formValid, setFormValid] = useState({});
  const [addRowStatus, setAddRowStatus] = useState({
    charge: false,
    discount: false,
  });
  const [controls, setControls] = useSetState({
    groupName: {
      type: "text",
      value: "",
      validation: {
        required: true,
      },
    },
    chargeProfile: {
      row: 1,
      type: "percent",
      value: 0,
      validation: {
        isPercent: true,
      },
    },
    chargeFitting: {
      row: 1,
      type: "percent",
      value: 0,
      validation: {
        isPercent: true,
      },
    },
    chargeGlass: {
      row: 1,
      type: "percent",
      value: 0,
      validation: {
        isPercent: true,
      },
    },
    chargeNet: {
      row: 1,
      type: "percent",
      value: 0,
      validation: {
        isPercent: true,
      },
    },
    chargeOther: {
      row: 1,
      type: "percent",
      value: 0,
      validation: {
        isPercent: true,
      },
    },
    discountProfile: {
      row: 2,
      type: "percent",
      value: 0,
      validation: {
        isPercent: true,
      },
    },
    discountFitting: {
      row: 2,
      type: "percent",
      value: 0,
      validation: {
        isPercent: true,
      },
    },
    discountGlass: {
      row: 2,
      type: "percent",
      value: 0,
      validation: {
        isPercent: true,
      },
    },
    discountNet: {
      row: 2,
      type: "percent",
      value: 0,
      validation: {
        isPercent: true,
      },
    },
    discountOther: {
      row: 2,
      type: "percent",
      value: 0,
      validation: {
        isPercent: true,
      },
    },
  });

  useEffect(() => {
    onClear();
  }, []);

  const onClear = () => {
    setCheckValid(false);
    setFormValid({ groupName: false });
    setControls({ groupName: { value: "" } });
    setControls({ chargeProfile: { value: 0 } });
    setControls({ chargeFitting: { value: 0 } });
    setControls({ chargeGlass: { value: 0 } });
    setControls({ chargeNet: { value: 0 } });
    setControls({ chargeOther: { value: 0 } });
    setControls({ discountProfile: { value: 0 } });
    setControls({ discountFitting: { value: 0 } });
    setControls({ discountGlass: { value: 0 } });
    setControls({ discountNet: { value: 0 } });
    setControls({ discountOther: { value: 0 } });
    setFormValid({ groupName: false });
    setAddRowStatus({ charge: false, discount: false });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const {
      groupName,
      chargeProfile,
      chargeFitting,
      chargeGlass,
      chargeNet,
      chargeOther,
      discountProfile,
      discountFitting,
      discountGlass,
      discountNet,
      discountOther,
    } = controls;
    if (
      !R.isEmpty(formValid) &&
      Object.values(formValid).every((item) => item === true)
    ) {
      try {
        setLoading(true);
        const data = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          Name: groupName.value,
          ChargeProfile: convertToEnglishNumber(chargeProfile.value),
          ChargeFitting: convertToEnglishNumber(chargeFitting.value),
          ChargeGlass: convertToEnglishNumber(chargeGlass.value),
          ChargeNet: convertToEnglishNumber(chargeNet.value),
          ChargeOther: convertToEnglishNumber(chargeOther.value),
          DiscountProfile: convertToEnglishNumber(discountProfile.value),
          DiscountFitting: convertToEnglishNumber(discountFitting.value),
          DiscountGlass: convertToEnglishNumber(discountGlass.value),
          DiscountNet: convertToEnglishNumber(discountNet.value),
          DiscountOther: convertToEnglishNumber(discountOther.value),
        };
        await dispatch(InsertGorouhMoshtariData(data));
        onClear();
        setLoading(false);
      } catch (e) {
        setLoading(false);
      }
    } else {
      setCheckValid(true);
    }
  };

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
  };

  const setRowStatus = (side) => {
    const value = addRowStatus[side];
    setAddRowStatus({
      ...addRowStatus,
      [side]: !value,
    });
  };

  return (
    <Grid container spacing={2} className="new-customer-group-section">
      <span className="normalTitle">{t("newCustomerGroup")}</span>
      <Grid item xs={12} className="px-0">
        <Input
          setValue={setValue.bind(this)}
          name="groupName"
          validation={controls.groupName.validation}
          label={<Translator id="name_groh_jadid" />}
          type="text"
          value={controls.groupName.value}
          checkValid={checkValid}
        />
      </Grid>
      <Grid
        item
        xs={12}
        className="new-customer-add-row"
        onClick={() => setRowStatus("charge")}
      >
        <div className="section-details">
          <span className="row-title">
            {t('customer_apply_custom_charge')}
          </span>
          <span className="exp d-none">
            {"پروفیل:۰ | یراق:۰ | شیشه:۰ | توری:۰ | دیگر:۰"}
          </span>
        </div>
        <Switch
          className={`switcher ${direction}`}
          color="primary"
          checked={addRowStatus.charge}
        />
      </Grid>
      {addRowStatus.charge &&
        Object.keys(controls)
          .filter((key) => controls[key].row === 1)
          .map((key, index) => {
            return (
              <Grid key={key + index} item sm={4} xs={6}>
                <Input
                  setValue={setValue.bind(this)}
                  value={controls[key].value}
                  name={key}
                  validation={controls[key].validation}
                  label={<Translator id={key} />}
                  type="text"
                  endIcon="%"
                />
              </Grid>
            );
          })}
      <Divider />
      <Grid
        item
        xs={12}
        className="new-customer-add-row"
        onClick={() => setRowStatus("discount")}
      >
        <div className="section-details">
          <span className="row-title">
            {t('customer_apply_custom_discount')}
          </span>
          <span className="exp d-none">
            {"پروفیل:۰ | یراق:۰ | شیشه:۰ | توری:۰ | دیگر:۰"}
          </span>
        </div>
        <Switch
          className={`switcher ${direction}`}
          color="primary"
          checked={addRowStatus.discount}
        />
      </Grid>
      {addRowStatus.discount &&
        Object.keys(controls)
          .filter((key) => controls[key].row === 2)
          .map((key, index) => {
            return (
              <Grid key={key + index} item sm={4} xs={6}>
                <Input
                  setValue={setValue.bind(this)}
                  value={controls[key].value}
                  name={key}
                  validation={controls[key].validation}
                  label={<Translator id={key} />}
                  type="text"
                  endIcon="%"
                />
              </Grid>
            );
          })}
      <Grid item xs={12} className="px-0">
        <MuiButton
          loading={loading}
          color="primary"
          title={<Translator id="ezafe_be_list" />}
          onClick={onSubmit}
          disabled={
            !formValid.groupName ||
            read("groupCustomerRules").accessRegister === false
          }
          className="w-100 mt-4"
        />
      </Grid>
    </Grid>
  );
}
